import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import MainCont from "../components/websiteDash/MainCont.vue";

const Register = () => import("../views/Register.vue");

const Dashboard = () => import("../views/Dashboard.vue");
const ModerMainCont = () => import("../components/mainDash/ModerMainCont.vue");
const Profile = () => import("../components/mainDash/Profile")
const Billing = () => import("../components/mainDash/Billing")
const Upgrade = () => import("../components/mainDash/Upgrade")
//const Connections = () => import("../components/admin/Connections")
const ChangePassword = () => import("../components/mainDash/ChangePassword")
const MainDash = () => import("../components/drip/welcome/MainDash")

const Website = () => import("../views/Website.vue")
const WelcomeDash = () => import("../components/drip/welcome/WelcomeDash")
const ManualSegm = () => import("../components/segmentation/ManualSegm")

const Notifications = () => import("../components/drip/recurring/Notifications.vue")
const Drafts = () => import("../components/drip/recurring/Drafts.vue")
const RecurringTails = () => import("../components/drip/recurring/RecurringTails.vue")
const RecurringSpam = () => import("../components/drip/recurring/RecurringSpam.vue")
const Edit = () => import("../components/drip/recurring/Edit.vue")
const Send = () => import("../components/drip/recurring/Send.vue")
const PageNotFound = () => import("../components/PageNotFound.vue")
const Integrate = () => import("../components/Integrate.vue")
const Integrate2 = () => import("../components/Integrate2.vue")
const Visualize = () => import("../components/segmentation/Visualize.vue")
const AudienceEdit = () => import("../components/segmentation/AudienceEdit.vue")
const AudienceCreate = () => import("../components/segmentation/AudienceCreate.vue")

const Management = () => import("../views/Management.vue");

import Clients from "../components/management/Clients.vue";
import Roles from "../components/management/Roles.vue";
import Clusters from "../components/management/Clusters.vue";

const UsersManagement = () => import("../components/mainDash/UsersManagement.vue");

import AudienceCreator from "../components/segmentation/AudienceCreator.vue";

import CopyAllDripsNew from "../components/drip_instruments/CopyAllDripsNew.vue";
import CopyAllDripsNew2 from "../components/drip_instruments/CopyAllDripsNew2.vue";
import RecurringMigration from "../components/drip_instruments/RecurringMigration.vue";

import TriggeredNotifications from "../components/automation/triggerPush/Triggers.vue";
import TriggerCreator from "../components/automation/triggerPush/Creator.vue";
import TriggerEdit from "../components/automation/triggerPush/Edit.vue";

import DripManagerPanel from "../views/DripManagerPanel.vue";
import DripSetup from "../components/drip_instruments/DripSetup.vue";
import TagsManager from "../components/mainDash/TagsManager.vue";
import DripManager from "../components/drip_instruments/Manager.vue";

import MainStats from "../components/mainDash/MainStats.vue";
import ClientPerformance from "../components/mainDash/ClientPerformance.vue";
import ServerPerformance from "../components/mainDash/ServerPerformance.vue";
import DataExplorer from "../components/mainDash/DataExplorer.vue";
import Files from "../components/mainDash/Files.vue";
import DomainList from "../components/mainDash/DomainList.vue";
import MoreInfo from "../components/websiteDash/MoreInfo.vue";
import MoreInfoSubs from "../components/websiteDash/MoreInfoSubs.vue";
import Compare from "../components/websiteDash/Compare.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      // {
      //   path: "",
      //   name: "MainCont",
      //   component: MainCont,
      // },
      {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
          guestOnly: true,
          title: "Login"
        },
      },
      {
        path: "/register",
        name: "Register",
        component: Register,
        meta: { guestOnly: true },
      },
    ]
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    props: true,
    meta: { authOnly: true, requiresPermissions: ["menu.admin.panel"] }
  },
  {
    path: "/moderation-dashboard",
    name: "ModerMainCont",
    component: ModerMainCont,
    meta: { authOnly: true } // , requiresPermissions: ["menu.clients.management"]
  },
  {
    path: "/dashboard/:id",
    component: Website,
    meta: { authOnly: true },
    children: [
      {
        path: "",
        name: "MainCont",
        component: MainCont,
      },
      {
        path: "recurring",
        name: "Recurring",
        component: Notifications,
        meta: { requiresPermissions: ["menu.domain.messages"] }
      },
            {
        path: "recurring/send",
        name: "Send",
        component: Send,
        meta: { requiresPermissions: ["menu.domain.messages"] }
      },
      {
        path: "recurring/drafts",
        name: "Drafts",
        component: Drafts,
        meta: { requiresPermissions: ["menu.domain.messages"] }
      },
      {
        path: "recurring/tails",
        name: "Recurring Tails",
        component: RecurringTails,
        meta: { requiresPermissions: ["menu.domain.messages"] }
      },
      {
        path: "recurring/spam",
        name: "Recurring Spam",
        component: RecurringSpam,
        meta: { requiresPermissions: ["menu.domain.messages", "menu.recurring.spam"] }
      },
      {
        path: "recurring/:group_id",
        name: "GroupedRecurrings",
        component: Notifications,
        //meta: { requiresPermissions: ["menu.domain.recurring.groupedByGroupId"] }
      },
      {
        path: "recurring/edit/:recurr_id",
        name: "EditRecurr",
        component: Edit,
        meta: { requiresPermissions: ["menu.domain.messages"] }
      },
      {
        path: "welcome",
        name: "MainDash",
        component: MainDash,
        meta: { requiresPermissions: ["menu.domain.messages"] }
      },
      {
        path: "welcome/:edit_id",
        name: "WelcomeDash",
        component: WelcomeDash,
        meta: { requiresPermissions: ["menu.domain.messages"] }
      },
      {
        path: "more-info",
        name: "More Info",
        component: MoreInfo,
        meta: { requiresPermissions: ["stats.domain"] }
      },
      {
        path: "more-info-subs",
        name: "More Info Subs",
        component: MoreInfoSubs,
        meta: { requiresPermissions: ["stats.domain"] }
      },
      {
        path: "more-info/compare",
        name: "Compare",
        component: Compare,
        meta: { requiresPermissions: ["stats.domain"] }
      },
      {
        path: "integrate",
        name: "Integrate",
        component: Integrate2,
        meta: { requiresPermissions: ["menu.domain.integrate"] }
      },
      {
        path: "integrate2",
        name: "Integrate2",
        component: Integrate2,
        meta: { requiresPermissions: ["menu.domain.integrate2"] }
      },
      {
        path: "audience-creator/view/:seg_id",
        name: "ViewAud",
        component: Visualize,
        meta: { requiresPermissions: ["menu.domain.audience"] }
      },
      {
        path: "manual-segmentation/view/:seg_id",
        name: "ViewSegm",
        component: Visualize,
        meta: { requiresPermissions: ["menu.admin.panel"] }
      },
      {
        path: "audience-creator",
        name: "Audience Creator",
        component: AudienceCreator,
        meta: { requiresPermissions: ["menu.domain.audience"] }
      },
      {
        path: "audience-creator/edit/:aud_id",
        name: "Edit Audience",
        component: AudienceEdit,
        meta: { requiresPermissions: ["menu.domain.audience.edit", "audience_edit"] }
      },
      {
        path: "audience-creator/create",
        name: "Audience Create",
        component: AudienceCreate,
        meta: { requiresPermissions: ["menu.domain.audience.create", "audience_create"] }
      },
      {
        path: "manual-segmentation",
        name: "Manual Segmentation",
        component: ManualSegm,
        meta: { requiresPermissions: ["menu.admin.panel"] }
      },
      {
        path: "triggers",
        name: "TriggeredNotifications",
        component: TriggeredNotifications,
        meta: {
          requiresPermissions: ["menu.domain.triggers"]
        },
      },
      {
        path: "triggers/create",
        name: "TriggerCreator",
        component: TriggerCreator,
        meta: {
          requiresPermissions: ["menu.domain.triggers.create"]
        },
      },
      {
        path: "triggers/edit/:trigger_id",
        name: "TriggerEdit",
        component: TriggerEdit,
        meta: {
          requiresPermissions: ["menu.domain.triggers.edit"]
        },
      },
      {
        path: "data-explorer",
        name: "DataExplorerWithDashboard",
        component: DataExplorer,
        meta: { authOnly: true, requiresPermissions: ["menu.analytics.data_explorer"] },
      },  
    ]
  },
  {
    path: "/management",
    component: Management,
    meta: { authOnly: true, requiresPermissions: ["menu.admin.panel"] },
    children: [
      {
        path: "clients",
        name: "Clients",
        component: Clients,
        meta: { requiresPermissions: ["menu.admin.panel"] },
      },
      {
        path: "roles",
        name: "Roles",
        component: Roles,
        meta: { requiresPermissions: ["menu.admin.panel"] },
      },
      {
        path: "clusters",
        name: "Clusters",
        component: Clusters,
        meta: { requiresPermissions: ["menu.admin.panel"] },
      },
    ]
  },
  {
    path: "/drip-tools",
    component: DripManagerPanel,
    meta: { authOnly: true },
    children: [
      {
        path: "",
        name: "Drip Manager",
        component: DripManager,
        meta: { requiresPermissions: ["menu.tools.drip_manager", "menu.tools"] },
      },
      {
        path: "/copy",
        name: "Copy All Drips New",
        component: CopyAllDripsNew,
        meta: { requiresPermissions: ["menu.clients.management", "menu.tools"] },
      },
      {
        path: "/copy_2",
        name: "Copy All Drips New 2",
        component: CopyAllDripsNew2,
        meta: { requiresPermissions: ["menu.tools.copy2"] },
      },
      {
        path: "/recurring_migration",
        name: "Recurring Migration",
        component: RecurringMigration,
        meta: { requiresPermissions: ["menu.tools.recurring_migration"] },
      },
      {
        path: "/instant-setup",
        name: "Drip Setup",
        component: DripSetup,
        meta: { requiresPermissions: ["menu.tools.drip_setup", "menu.tools"] },
      },
    ]
  },
  {
    path: "/users-management",
    name: "UsersManagement",
    component: UsersManagement,
    meta: { authOnly: true, requiresPermissions: ["menu.users.management"] },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { authOnly: true },
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { authOnly: true },
  },
  {
    path: "/upgrade",
    name: "Upgrade",
    component: Upgrade,
    meta: { authOnly: true },
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    meta: { authOnly: true },
  },
  {
    path: "/tags-manager",
    name: "Tags Manager",
    component: TagsManager,
    meta: { authOnly: true, requiresPermissions: ["menu.tags.manager"] },
  },
  {
    path: "/global-stats",
    name: "Main Stats",
    component: MainStats,
    meta: { authOnly: true, requiresPermissions: ["menu.stats.global", "menu.clients.management"] },
  },
  {
    path: "/performance",
    name: "ClientPerformance",
    component: ClientPerformance,
    meta: { authOnly: true, requiresPermissions: ["menu.analytics.performance"] },
  },
  {
    path: "/server-performance",
    name: "ServerPerformance",
    component: ServerPerformance,
    meta: { authOnly: true, requiresPermissions: ["menu.analytics.server_performance"] },
  },
  {
    path: "/data-explorer",
    name: "DataExplorer",
    component: DataExplorer,
    meta: { authOnly: true, requiresPermissions: ["menu.analytics.data_explorer"] },
  },
  {
    path: "/files",
    name: "Files",
    component: Files,
    meta: { authOnly: true, requiresPermissions: ["menu.files"] },
  },
  {
    path: "/domain-list",
    name: "Domain List",
    component: DomainList,
    meta: { authOnly: true, requiresPermissions: ["menu.domain_list"] },
  },
  {
    path: "*",
    name: "Page Not Found",
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;